<template>
    <div>
        <ion-header>
            <ion-toolbar>
                <ion-title>{{ $t('components.custom-date.title') }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button @click="dismiss" slot="icon-only"><ion-icon name="close-circle-outline"></ion-icon></ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding" text-center>
            {{ $t('components.custom-date.message') }}<br /><br />
            <ion-item lines="none" text-center>
                <ion-button fill="outline" size="default" class="select-date"><ion-datetime v-on:ionChange="start_date = $event.target.value" display-format="D MMMM" :placeholder="$t('components.custom-date.placeholder-start')" text-center></ion-datetime></ion-button>
            </ion-item>
            <ion-item lines="none" text-center>
                <ion-button fill="outline" size="default" class="select-date"><ion-datetime v-on:ionChange="end_date = $event.target.value" display-format="D MMMM" :placeholder="$t('components.custom-date.placeholder-end')"></ion-datetime></ion-button>
            </ion-item>
            <ion-button @click="save">Save</ion-button>
        </ion-content>
    </div>
</template>

<script>
export default {
    name: 'CustomDate',
    data() {
        return {
            start_date: '',
            end_date: ''
        }
    },
    methods: {
        dismiss: function() {
            this.$logger.debug('dismiss');
            this.$parent.$emit('dismissModal');
        },
        save: function() {
            this.$logger.debug('save');
            const start = new Date(this.start_date);
            const end = new Date(this.end_date);


            this.$logger.debug('v-model', start.getDate() + '-' + start.getMonth(), end.getDate() + '-' + end.getMonth());
            this.$parent.$emit('saveModal', start.getDate() + '-' + start.getMonth(), end.getDate() + '-' + end.getMonth());
        }
    }
}
</script>

<style scoped>
ion-datetime {
    color: var(--color-activated);
    padding: 0;
}

ion-content ion-button {
    margin: .5em auto !important;
}

ion-item {
    --background-hover: none;
}

ion-icon {
    font-size: 1.8em;
    color: #999;
}

.select-date {
    font-size: .7em;
}
</style>